import { eventManager } from 'ats/utils/EventManager';

export const TASK_FOCUS_EVENT = 'timelineTaskFocusRequested';

const FOCUS_HIGHLIGHT_MS = 2000;

export function requestTaskFocus({ scope, entityId, taskId }) {
	eventManager.emit(TASK_FOCUS_EVENT, { scope, entityId, taskId });
}

export function isFocusRequestFor(request, scope, entityId) {
	return (
		request?.scope === scope && String(request?.entityId) === String(entityId)
	);
}

function highlight(element) {
	element.scrollIntoView({ behavior: 'smooth', block: 'center' });
	element.classList.remove('is-focused');
	// Restart the animation when the same card is focused twice in a row.
	void element.offsetWidth;
	element.classList.add('is-focused');
	setTimeout(() => element.classList.remove('is-focused'), FOCUS_HIGHLIGHT_MS);
}

/**
 * Scrolls the timeline to the task card, loading the page that holds it when
 * the task is not on the page currently shown.
 */
export async function focusTimelineTask({ container, listStore, taskId }) {
	const findCard = () => container?.querySelector(`[data-task-id="${taskId}"]`);

	if (!findCard()) {
		listStore.store.setQuery('locateTaskId', taskId);
		try {
			await listStore.search();
		} finally {
			listStore.store.setQuery('locateTaskId', undefined);
		}
	}

	requestAnimationFrame(() => {
		const card = findCard();
		if (card) highlight(card);
	});
}
